import { DocumentStateResource } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

type StatesQueryObject = Record<string, string[]>;

export const postApplicationDocumentStates = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: StatesQueryObject,
): Promise<NonPaginatedResponse<DocumentStateResource[]> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/states`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
